import axios, { AxiosResponse } from 'axios';

import { useSessionStorage } from 'shared/src/composables/storage/useSessionStorage';
import { LogoutType } from 'shared/clients/client-spa-AccountGroup';
import { DESTINATION_APP_TYPE, MESSAGE_TYPE } from 'shared/src/composables/messages/messages.model';
import { useMessages } from 'shared/src/composables/messages/useMessages.composable';
import type { RemovableRef } from 'shared/src/composables/storage/shared';
import { SsoConfig } from 'shared/typings/appSettings';

const refreshPage = () => {
  window.location.reload();
  window.location.href = '/';
};

class AuthorizationService {
  private orgId: RemovableRef<string | null> = useSessionStorage('orgId', null);
  private useMessages = useMessages();

  public loginAsOrganization(organizationNip: string): void {
    this.orgId.value = organizationNip;
    refreshPage();
  }

  public loginAsNaturalPerson(): void {
    this.clearOrgId();
    refreshPage();
  }

  public clearOrgId = (): void => {
    this.orgId.value = null;
  };

  public postLogoutMessage = (logoutType: LogoutType): void => {
    this.useMessages.postWindowMessage(DESTINATION_APP_TYPE.HOST, MESSAGE_TYPE.LOGOUT, logoutType);
  };

  public async getTokenForChatBot(ssoConfig: SsoConfig, token: string | undefined): Promise<AxiosResponse> {
    const params = {
      'grant_type': 'scopeReduceTokenExchange',
      'token': token ?? '',
      'client_id': ssoConfig.ClientId,
      'scope': 'ChatApi.UserAccess openid profile',
    };
    
    return axios.post(`${window.appSettings.Sso.Authority}/connect/token`, new URLSearchParams(params).toString());
  }
}

export default new AuthorizationService();
